export default "__VITE_ASSET__DNhUtx4d__"